/**
 * 实时视图探针（P0-5）：CameraDirector 在 Canvas 内注册读取函数，
 * 页面层用它"记录当前视图"为新机位（视口 → 工程数据的唯一回写通道）。
 * 结构同 runtimeRegistry：命令式旁路，不进 React 状态，避免每帧重渲染。
 */
export interface LiveView {
  px: number;
  py: number;
  pz: number;
  tx: number;
  ty: number;
  tz: number;
  fov: number;
}

export const viewProbe: { get: () => LiveView | null } = {
  get: () => null,
};

/** PiP 角标文案（页面层 HTML 用）：选中机位且处于自由视角时显示，否则 null */
export function pipBadgeText(
  selectedCam: { name: string; fov: number } | null,
  viewMode: 'free' | 'camera',
): string | null {
  if (selectedCam === null || viewMode === 'camera') {
    return null;
  }
  return `取景预览 · ${selectedCam.name} · FOV ${selectedCam.fov.toFixed(0)}°`;
}
